import BrochureFormPaid from '../components/brochureFormPaid';
import InformationFormBasic from '../components/informationFormBasic';
import InformationFormPaid from '../components/informationFormPaid';
import RequestTourForm from '../components/requestTourForm';
import BrochureFormLimitedAvailability from '../components/brochureFormLimitedAvailability';
import LeadFormType from '../enums/leadFormType';
import AskQuestionFormPaid from '../components/askQuestionFormPaid';
import ManufacturedBrochureFormPaid from '../components/manufacturedBrochureFormPaid';

const leadGeneratorConstructors = new Map();

leadGeneratorConstructors.set(LeadFormType.BrochureFormPaid.toString(), BrochureFormPaid);
leadGeneratorConstructors.set(LeadFormType.InformationFormPaid.toString(), InformationFormPaid);
leadGeneratorConstructors.set(LeadFormType.RequestTourForm.toString(), RequestTourForm);
leadGeneratorConstructors.set(LeadFormType.BrochureFormLimitedAvailability.toString(), BrochureFormLimitedAvailability);
leadGeneratorConstructors.set(LeadFormType.InformationFormBasic.toString(), InformationFormBasic);
leadGeneratorConstructors.set(LeadFormType.AskQuestionFormPaid.toString(), AskQuestionFormPaid);
leadGeneratorConstructors.set(LeadFormType.ManufacturedBrochureFormPaid.toString(), ManufacturedBrochureFormPaid);

/**
 * Returns the class constructor to create a lead generator.
 *
 * @param leadGeneratorName - The name of the lead generator requested.
 */
export default (leadGeneratorName, properties) => {
  const generator = leadGeneratorConstructors.get(leadGeneratorName);

  if (!generator) {
    return null;
  }

  return new generator.prototype.constructor(properties);
};
